//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../no/ugmath.js";
let d=[[[0,"Added",1,0],[0,"OnTool",1,0],[0,"Removed",1,0]],[[["numEntities","entities"],"GetFaceSelectors",{},0,0],[["entities"],"SetFaceSelectors",{},1,0],[["entity"],"SetOneFaceSelector",{},1,0],[["numEntities","entities"],"GetEdgeSelectors",{},0,0],[["entities"],"SetEdgeSelectors",{},1,0],[["entity"],"SetOneEdgeSelector",{},1,0],[["numEntities","entities","extremities"],"GetVertexSelectors",{},0,0],[["entity","extremity"],"SetOneVertexSelector",{},2,0],[["entities","extremities"],"SetVertexSelectors",{},2,0],[["location"],"SetOnePointSelector",{},1,0],[[],"GetOwningBody",{R_:{owningBodyEid:"Body"}},0,0],[["owningBodyEid"],"SetOwningBody",{},1,0],[["boundaryBodyEid","sideness"],"AppendOneBoundaryBody",{},2,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.RegionTracker = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.RegionTracker";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.RegionTracker.ExtremityType = Object.freeze({
    "Start" : "Start", "End" : "End"});

export default SPLM;